import React from "react";
import { useTranslation } from 'react-i18next';

export default function StatusPill({value}) {
    const { t } = useTranslation();
    return (
        <div
            style={{
                backgroundColor: value === true ? '#88D36ECC' : '#A9A9A9CC',
                color: value === true ? '#2A880A' : '#808080',
                fontWeight: 500,
                textAlign: 'center',
                borderRadius: '9px',
                padding: '2px 10px',
                userSelect: "none"
            }}
        >
            {value === true ? t('pduis.active') : t('pduis.inactive')}
        </div>
    )
}